export default function (path) {
    if (['http', 'https'].every(protocol => path.indexOf(protocol) !== -1)) {
        return path.replace(/.*\/\/[^/]*/, '');
    }
    return path;
}
